import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ROLE } from "./constant/roles";
import LoginPage from "./pages/auth/LoginPage";

const ProtectedRoute = ({ allowedRoles }) => {
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    const role = user ? ROLE[user.role_id] : null;

    if (!user) {
        return <Navigate to="/login" replace />;
    }
    if (!allowedRoles.includes(role)) {
        if (role === "admin") return <Navigate to="/admin" replace />;
        if (role === "receptionist") return <Navigate to="/receptionist" replace />;
        console.log(allowedRoles);
        console.log(role);
        console.log(user);
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
};

export default ProtectedRoute;


export const PublicRoute = ({ children }) => {
    const storedUser = localStorage.getItem("user");

    if (!storedUser) {
        alert
        return <Navigate to="/login" replace />;
    }
    if (storedUser) {
        const user = JSON.parse(storedUser);
        const role = ROLE[user.role_id];
        if (role === "admin") return <Navigate to="/admin" replace />;
        if (role === "receptionist") return <Navigate to="/receptionist" replace />;
        return <Navigate to="/login" replace />;
    }

    return children;
};
export const LoginRedirect = () => {
    const storedUser = localStorage.getItem("user");

    // ✅ If logged in → redirect to respective dashboard
    if (storedUser) {
        const user = JSON.parse(storedUser);
        const role = ROLE[user.role_id];

        if (role === "admin") return <Navigate to="/admin" replace />;
        if (role === "receptionist") return <Navigate to="/receptionist" replace />;
    }

    // ✅ If not logged in → show login page
    return <LoginPage />;
};
